import { Injectable } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})

export class SwalFireService {
  SwalFireQuestion(
    title: string,
    text: string,
    confirm: string,
    cancel: string
  ): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      html: `<div class="swal2-content-custom">${text}</div>`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
      confirmButtonText: confirm,
      confirmButtonColor: '#00910c',
      cancelButtonText: cancel,
      cancelButtonColor: '#e5e5e5',
      customClass: {
        title: 'swal2-title-custom',
        popup: 'swal2-popup-custom',
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom',
        actions: 'swal2-actions-custom',
      },
      reverseButtons: true,
    });
  }
}
